import { takeLatest, put, call } from 'redux-saga/effects';
import * as DiyConfigActions from './action'
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { CORE_API } from '../../../config';

export function* kibanaConfig(action) {//counterparty/autocomplete/name/{searchText}
    let requestUrl = `${CORE_API}/kibana/config/save`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(DiyConfigActions.setKibanaConfigSuccess(searchResult.data));
    } catch (err) {
        yield put(DiyConfigActions.setKibanaConfigFailure(err.response))
    }
}
export function* setKibanaConfig() {
    yield takeLatest(DiyConfigActions.KIBANA_CONFIG_SAVE, kibanaConfig);
}

export function* downloadKeys(action) {//counterparty/autocomplete/name/{searchText}
    let requestUrl = `${CORE_API}/kibana/config/save`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(DiyConfigActions.downloadKeyExtractionSuccess(searchResult.data));
    } catch (err) {
        yield put(DiyConfigActions.downloadKeyExtractionFailure(err.response))
    }
}
export function* downloadKeyExtracion() {
    yield takeLatest(DiyConfigActions.DOWNLOAD_KEY_EXTRACTION, downloadKeys);
}